<template>
    <div>
        <vs-divider color="primary">
            {{ $t('details') | capitalize }}
        </vs-divider>
        <vs-table :data="data" noDataText="">
            <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th>{{ $t('description') | capitalize }}</vs-th>
                <vs-th>{{ $t('quantity') | capitalize }}</vs-th>
                <vs-th>{{ $t('unit_cost') | capitalize }}</vs-th>
                <vs-th>{{ $t('total') | capitalize }}</vs-th>
                <vs-th></vs-th>
            </template>
            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
                    <vs-td>
                        {{ i + 1 }}
                    </vs-td>
                    <vs-td>
                        {{ tr.description }}
                    </vs-td>
                    <vs-td>
                        {{ formatNumber(tr.quantity) }}
                    </vs-td>
                    <vs-td>
                        ${{ formatNumber(tr.price, 2) }}
                    </vs-td>
                    <vs-td>
                        ${{ formatNumber(tr.total, 2) }}
                    </vs-td>
                    <vs-td>
                        <feather-icon icon="TrashIcon" style="color:'#cf1100'}"
                            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="remove(i)" />
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

       
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        }
    },
    methods: {
        remove(i){
            this.$emit('remove',i)
        }

    },
}
</script>